import { jsxs as m, jsx as e } from "react/jsx-runtime";
import * as o from "react";
import { cva as c } from "class-variance-authority";
import { Loader2 as x } from "lucide-react";
import { cn as s } from "../../../lib/utils.js";
const f = c("animate-spin", {
  variants: {
    size: {
      xs: "h-3 w-3",
      sm: "h-4 w-4",
      md: "h-6 w-6",
      lg: "h-8 w-8",
      xl: "h-12 w-12"
    },
    variant: {
      default: "text-lpr-gold",
      primary: "text-lpr-gold",
      secondary: "text-text-primary",
      white: "text-bg-surface",
      muted: "text-text-secondary"
    }
  },
  defaultVariants: {
    size: "md",
    variant: "default"
  }
}), i = o.forwardRef(({ className: r, size: t, variant: n, label: a, ...l }, d) => m("div", { ref: d, className: s("flex flex-col items-center justify-center gap-2", r), role: "status", "aria-label": a || "Loading", ...l, children: [e(x, { className: s(f({ size: t, variant: n })) }), a && e("span", { className: "text-sm text-text-secondary", children: a })] }));
i.displayName = "Spinner";
const y = ({ label: r = "Loading...", visible: t = !0 }) => t ? e("div", { className: "fixed inset-0 z-50 flex items-center justify-center bg-bg-primary/30 backdrop-blur-sm animate-fadeIn", children: e("div", { className: "rounded-xl bg-bg-surface p-8 shadow-luxury", children: e(i, { size: "xl", label: r }) }) }) : null;
export {
  i as Spinner,
  y as SpinnerOverlay
};
//# sourceMappingURL=Spinner.js.map
